/** vs-par token → numeric (0 for E / unknown). */
export function parseVsParNumber(token) {
    const t = String(token).trim();
    if (t === "E" || t === "e") return 0;
    const m = /^([+-]?\d+)/.exec(t);
    if (m) return parseInt(m[1], 10);
    return 0;
}

/** plain | circle (under par) | square (over par) */
export function scoreChipKind(token) {
    const t = String(token).trim();
    if (t === "E" || t === "e") return "plain";
    const n = parseVsParNumber(token);
    if (n === 0) return "plain";
    if (n < 0) return "circle";
    return "square";
}

/**
 * Hole result chip: no border for par; circle for under; square for over.
 * @param {"card" | "dark"} tone
 */
export function recentHoleChipClass(kind, tone) {
    const borderDark = "border border-masters-cream/45";
    const borderCard = "border border-masters-moss/50";
    const border = tone === "dark" ? borderDark : borderCard;
    const base =
        "inline-flex shrink-0 items-center justify-center box-border text-[11px] font-medium leading-none tabular-nums";
    if (kind === "plain") return "";
    if (kind === "circle") {
        return `${base} ${border} h-[1.375rem] w-[1.375rem] rounded-full`;
    }
    return `${base} ${border} min-h-[1.375rem] min-w-[1.375rem] rounded-none px-1`;
}
